// Libs
import React from 'react'
import PropTypes from 'prop-types'

// Styles
import {
  dateButtonStyle,
  clearDateButtonStyle,
} from '../styles'

const ClearDateButton = ({onClick, isOpen, text = 'Clear date'}) => {
  if (isOpen) {
    return (
      <div data-test='ClearDateButton' style={clearDateButtonStyle}>
        <button
          type='button'
          style={dateButtonStyle}
          onClick={onClick}>{text}</button>
      </div>
    )
  }

  return null
}

ClearDateButton.propTypes = {
  onClick: PropTypes.func,
  isOpen: PropTypes.bool,
  text: PropTypes.string,
}

export default ClearDateButton
